import React from "react";
import {
  DynamicFormWithFiles as Dform,
  //  DynamicFieldWithFiles as Dfield,
} from "@heartfulnessinstitute/react-hfn-forms/dist/ui/DynamicFormWithFiles";
import getFirebaseApp1 from "gatsby-plugin-hfn-profile/components/Firebase";

export const getFirebaseApp = getFirebaseApp1;

const DynamicFormWithFiles = (props) => {
  const firebaseStorage = getFirebaseApp().storage();
  return <Dform {...props} firebaseStorage={firebaseStorage} />;
};

export default DynamicFormWithFiles;

// export const DynamicFieldWithFiles = (props) => (
//   <Dfield {...props} type="firebasefile" firebaseStorage={firebaseStorage} />
// );

// <DynamicFieldsWithFiles name="xyz" value={file} setValue={setFile} firebaseStorage={getFirebaseApp().storage()} namespace="form-abcd" props={{config:{maxBytes: 100000}}} />
